import { Api } from "services/api/api.service";
import {
  isValidPersonalIdentityNumber,
  normalizePersonalIdentityNumber,
} from "web-apps/company/utils/personalIdentityNumber.utils";

/**
 * True when the personal identity number is complete enough for Skatteverket to
 * be asked about it. Anything else is a guaranteed miss, so the lookup is not
 * worth running — and callers use this to decide whether to offer it at all.
 */
export const canLookupTaxTable = (
  personalIdentityNumber: string | null,
): boolean => {
  return isValidPersonalIdentityNumber(personalIdentityNumber ?? "");
};

/**
 * Asks for the tax table registered for a personal identity number. Resolves to
 * null when there is none: the backend reports that as a missing or
 * non-positive table rather than as an error.
 */
export const lookupTaxTable = async (params: {
  companyId: number;
  personalIdentityNumber: string;
}): Promise<number | null> => {
  const response = await Api().taxTable.getTaxTableByPersonalNumber({
    companyId: params.companyId,
    personalNumber: normalizePersonalIdentityNumber(
      params.personalIdentityNumber,
    ),
  });

  const foundTaxTable = response.data?.data?.taxTable;
  if (typeof foundTaxTable !== "number" || foundTaxTable <= 0) return null;
  return foundTaxTable;
};
